<oui-document-viewer class="slide-wrapper" [documentUrl]="documentUrl" [showControls]="true" *ngIf="documentUrl">
  <div class="document-controls" oui-document-controls>
    <div class="document-name-container">
      <div class="document-name">
        <div class="headline-5">Fiche conseil</div>
        <oui-button type="icon" color="secondary" (click)="closeSlidePanel()">
          <oui-icon>close</oui-icon>
        </oui-button>
      </div>
      <div class="subtitle body-1">{{ operationType }} - {{ productType }}</div>

      @if (personType === 'PERSONNE_PHYSIQUE'){
      <div class="subtitle body-1">Personne physique</div>
      } @else {
      <div class="subtitle body-1">Personne morale</div>
      }
    </div>
    <div class="document-name-and-date">
      <div class="file-name-with-icon body-2">
        <oui-icon svgIcon="pdf"></oui-icon>
        <span class="file-name"> {{ storageFile?.denomination }}.{{ storageFile?.fileExtension }} </span>
      </div>
      <div class="document-date">Généré le {{ creationDate | date : 'dd/MM/yyyy à HH:mm' }}</div>
    </div>
    <div class="document-actions">
      <oui-button class="download-button" type="contained" (click)="onDownloadClick()" iconPrefix="download"
        >Télécharger la fiche conseil</oui-button
      >
    </div>
  </div>
</oui-document-viewer>
